import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {Doughnut} from 'react-chartjs-2';
const options={
    responsive: true,
    maintainAspectRatio: false,
    title: {
        display: true,
        text: 'Units Released'
    }    
}
class UnitsReleasedChart extends Component{
    constructor(props){
        super(props);
        this.state={            
            chartObj:{
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55'
                    ],
                    hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55'
                    ]
                }]
            },
        }      
    }
    componentWillMount=()=>{
        let _chartObj=this.state.chartObj;            
        _chartObj.labels=[];
        _chartObj.datasets[0].data=[];
        if(this.props.reportDashboard.unitsReleased.length>0){
        this.props.reportDashboard.unitsReleased.map((value,item)=>{
            _chartObj.labels.push(value.dropOffLocation);
            _chartObj.datasets[0].data.push(value.unitsRelease);           
        })
        }
        this.setState({ chartObj:_chartObj}); 
    }
    render(){
        return(
            <div class="row"> 
                <div class="pull-right col-md-12"> 
                    <Link class="btn btn-info" to="/reports-dashboard"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back </Link>
                </div>
                <div class="clear"></div>
                <div class="col-md-8 col-md-offset-2" style={{backgroundColor: 'rgba(0, 0, 0, 0.14)'}}>           
                    <Doughnut height="440" data={this.state.chartObj} options={options}/> 
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        authInfo: state.authInfo,
        reportDashboard:state.reportDashboard
        //refNotify:state.refNotify
    }
};

export default connect(mapStateToProps)(UnitsReleasedChart);